import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { BaseSubmissionInformation } from './base-submission-information.component';
import { styleVariables } from '@lib/common';
import { Col, Row, Skeleton, Space } from 'antd';
import styled from 'styled-components';
import { SubmissionScore, UnixTimestamp } from '@module/assignment';
import { QuestionReleases } from '@module/form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SectionGradeRow = styled(Row).withConfig({
  displayName: "examination-submission-informationcomponent__SectionGradeRow",
  componentId: "sc-eh4ryi-0"
})(["width:100%;display:flex;flex-wrap:wrap;margin:0 auto 16px auto;"]);
var SectionGradeItem = styled.div.withConfig({
  displayName: "examination-submission-informationcomponent__SectionGradeItem",
  componentId: "sc-eh4ryi-1"
})([""]);
var SectionGradeSummary = styled(Space).withConfig({
  displayName: "examination-submission-informationcomponent__SectionGradeSummary",
  componentId: "sc-eh4ryi-2"
})(["width:100%;margin-block:8px;padding-inline:16px;"]);
var SubmissionResultCard = styled.div.withConfig({
  displayName: "examination-submission-informationcomponent__SubmissionResultCard",
  componentId: "sc-eh4ryi-3"
})(["display:flex;flex-direction:row;align-items:center;justify-content:center;height:36px;padding:16px;border-radius:8px;gap:8px;background-color:", ";", ""], styleVariables.colors.blue1, function (props) {
  return props.theme.media.desktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex-direction: column;\n    height: 100%;\n  "])));
});
var NumberOfCorrectAnswerLabel = styled.label.withConfig({
  displayName: "examination-submission-informationcomponent__NumberOfCorrectAnswerLabel",
  componentId: "sc-eh4ryi-4"
})(["font-weight:600;font-size:14px;line-height:24px;", ""], function (props) {
  return props.theme.media.desktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: 16px;\n  "])));
});
var GrayText = styled.label.withConfig({
  displayName: "examination-submission-informationcomponent__GrayText",
  componentId: "sc-eh4ryi-5"
})(["font-weight:400;font-size:14px;line-height:24px;color:", ";", ""], styleVariables.colors.gray11, function (props) {
  return props.theme.media.desktop(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-size: 16px;\n  "])));
});
var SubmissionScoreText = styled.label.withConfig({
  displayName: "examination-submission-informationcomponent__SubmissionScoreText",
  componentId: "sc-eh4ryi-6"
})(["font-weight:600;font-size:14px;line-height:24px;color:", ";", ""], styleVariables.colors.blue2, function (props) {
  return props.theme.media.desktop(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    font-size: 16px;\n  "])));
});
export var ExaminationSubmissionInformation = function ExaminationSubmissionInformation(props) {
  var isLoadingGetFormReleaseById = props.isLoadingGetFormReleaseById,
      isLoadingGetSubmissionById = props.isLoadingGetSubmissionById,
      isPassed = props.isPassed,
      scorePerSection = props.scorePerSection,
      formRelease = props.formRelease,
      assignment = props.assignment,
      isLoadingGetAssignmentById = props.isLoadingGetAssignmentById,
      submission = props.submission,
      label = props.label,
      _props$isShowingTotal = props.isShowingTotalScore,
      isShowingTotalScore = _props$isShowingTotal === void 0 ? false : _props$isShowingTotal,
      _props$questionReleas = props.questionReleases,
      questionReleases = _props$questionReleas === void 0 ? [] : _props$questionReleas;

  var getSectionTotalQuestions = function getSectionTotalQuestions(sectionId, fallback) {
    if (questionReleases.length > 0) {
      return QuestionReleases.totalQuestionsBySection(questionReleases, sectionId);
    }

    return fallback !== null && fallback !== void 0 ? fallback : 0;
  };

  var renderSubmissionResultInformation = function renderSubmissionResultInformation() {
    var now = parseInt(UnixTimestamp.now());
    var assignmentEndTime = assignment === null || assignment === void 0 ? void 0 : assignment.endTime;
    var isNotEndedAssignment = now - assignmentEndTime < 0;

    if (isNotEndedAssignment || !isShowingTotalScore) {
      return;
    }

    var isLoadingResources = isLoadingGetSubmissionById || isLoadingGetAssignmentById || isLoadingGetFormReleaseById;

    if (isLoadingResources) {
      return /*#__PURE__*/_jsx(Skeleton, {
        active: true
      });
    }

    var totalScore = formRelease.sections.reduce(function (sum, currentSection) {
      return sum + currentSection.totalScore;
    }, 0);
    return /*#__PURE__*/_jsx(Col, {
      xs: 24,
      xl: 12,
      children: /*#__PURE__*/_jsxs(SubmissionResultCard, {
        children: [/*#__PURE__*/_jsx(GrayText, {
          children: label.totalScore
        }), /*#__PURE__*/_jsxs(SubmissionScoreText, {
          children: [typeof submission.result.score === 'number' && submission.result.score !== SubmissionScore["default"].value && submission.result.score >= 0 ? submission.result.score : 0, "/", totalScore, " ", label.score]
        })]
      })
    });
  };

  var renderSectionSummaries = function renderSectionSummaries() {
    if (isLoadingGetFormReleaseById || !scorePerSection.length) {
      return /*#__PURE__*/_jsx(Skeleton, {
        active: true
      });
    }

    return /*#__PURE__*/_jsx(SectionGradeRow, {
      children: formRelease.sections.map(function (section, index) {
        return /*#__PURE__*/_jsx(SectionGradeItem, {
          children: /*#__PURE__*/_jsxs(SectionGradeSummary, {
            direction: "vertical",
            size: "small",
            children: [/*#__PURE__*/_jsxs("span", {
              children: [label.section, " ", index + 1]
            }), assignment.isShowingScore ? /*#__PURE__*/_jsxs(NumberOfCorrectAnswerLabel, {
              children: [scorePerSection[index], "/", section.totalScore, " ", label.score]
            }) : /*#__PURE__*/_jsxs(NumberOfCorrectAnswerLabel, {
              children: [getSectionTotalQuestions(section.id.toString(), section.totalQuestion), ' ', label.numberOfQuestion]
            })]
          })
        }, section.index);
      })
    });
  };

  return /*#__PURE__*/_jsx(BaseSubmissionInformation, _objectSpread(_objectSpread({}, props), {}, {
    resultColumn: renderSubmissionResultInformation(),
    children: renderSectionSummaries()
  }));
};